export default "https://cdn-static.gokick.com/assets/76516c8a60965c2814adf9f2d5cc0638cda6ee5d/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";